module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXklEQVR4AWMYHOCcoNp/cvAgMuDPRbH/2PCFNUJgjEOesAH1WdwgTLoBK3v4//NwMYIUgDE/DyNIjDQXHFwgCDMAxCbdCx2FPP+rUrlBGMTGbwBDtv1/svDAGzA8AAAKQlDJqZSvXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GH.png
// module id = 1147
// module chunks = 0